import { SEARCH_STRATEGIES } from "@/search/search.constants";
import useGetDeliverySearch from "@/search/useGetDeliverySearch";
import contentTypes from "@/view/constants/contentTypes";
import { extractResults } from "./utils";

const useFetchRelatedContentCards = ({
  contentId,
  isStudent = true,
  legacyFormat = false,
}: {
  contentId: string | number;
  isStudent?: boolean | undefined;
  legacyFormat?: boolean | undefined;
}) => {
  const RELATED_CARDS_COUNT = 4;
  const contentTypesFilterForStudents = [
    contentTypes.GENERATION_GENIUS_VIDEO,
    contentTypes.ARTICLE,
    contentTypes.INTERACTIVE_VIDEO,
  ];

  const queryParams: Record<string, any> = {
    strategy: SEARCH_STRATEGIES.SIMILAR_TO,
    similar_to: contentId,
    ...(!isStudent ? {} : { content_types: contentTypesFilterForStudents }),
    page_size: RELATED_CARDS_COUNT,
  };

  const { data, refetch: fetchRelatedContentCards } = useGetDeliverySearch({
    queryParams,
  });

  const filteredCards = extractResults({
    data,
    limit: RELATED_CARDS_COUNT,
    legacyFormat,
  });

  return { fetchRelatedContentCards, filteredCards };
};

export default useFetchRelatedContentCards;
